/*
  ! 🐒 Monkey patch alert 🙈

  ! Chrome, and possibly others, may not fire "composition end" events in very
  ! specific conditions. Slate-react highly depends on a reliable chain of
  ! composition events. If the end one is missing, the editor is locked into
  ! composition and returns early for a lot of input events.

  ! This patch here checks if a keydown event is not part of a composition
  ! anymore. If this happen before a composition end is fired, the bug
  ! triggered, and we manually reset internal Slate composition state.
  */
import React, { Fragment } from 'react';
import { findRange } from 'slate-react';
import { IS_MAC, IS_CHROME, window } from '../../../helpers/BrowserHelpers';
import DocumentEventListener from '../../../components/DocumentEventListener';
export default function makeOnCompositionFail() {
  var isComposing = false;

  var checkCompositionState = function checkCompositionState() {};

  var onCompositionStart = function onCompositionStart() {
    isComposing = true;
  };

  var onCompositionEnd = function onCompositionEnd() {
    isComposing = false;
  };

  return {
    onConstruct: function onConstruct(editor, next) {
      checkCompositionState = function checkCompositionState(event) {
        // event.isComposing could be undefined on some old browser
        if (isComposing && event.isComposing === false) {
          editor.run('onCompositionEnd', event);
          isComposing = false;
        }
      };

      return next();
    },
    onBeforeInput: function onBeforeInput(event, editor, next) {
      // TODO: Drop me when 0.47 and slate#3113 are merged
      if (!IS_MAC || !IS_CHROME || isComposing) return next();
      var selection = window.getSelection();
      if (selection.isCollapsed) return next();
      if (editor.value.selection.isExpanded) return next();
      editor.withoutSaving(function () {
        var range = findRange(selection, editor);
        editor.select(range);
      });
    },
    renderEditor: function renderEditor(props, editor, next) {
      return React.createElement(Fragment, null, next(), React.createElement(DocumentEventListener, {
        onKeyDown: checkCompositionState,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd
      }));
    }
  };
}